var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAngleUp16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.24 10.561c-.396.518-1.103.588-1.578.156L8.795 7.916c-.288-.209-.431-.313-.586-.353a.826.826 0 0 0-.418 0c-.155.04-.298.144-.586.353l-3.867 2.801c-.475.432-1.182.362-1.578-.156-.396-.518-.332-1.287.143-1.718.434-.393 2.65-2.358 4.287-3.806.644-.57.967-.856 1.325-.965.317-.096.652-.096.968 0 .359.11.681.396 1.326.968l4.288 3.803c.475.431.54 1.2.143 1.718Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleUp16);
export default __webpack_public_path__ + "static/media/angle_up_16.12931079.svg";
export { ForwardRef as ReactComponent };